import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, loginRequest } from '../../config/msalConfig.ts';
import { post } from '../api/base';
import env from '../../Env';

export const msalInstance = new PublicClientApplication(msalConfig);

export const fetchOAuthProviders = async () => {
  const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID;
  const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID;
  if (!clientId || !tenantId) return [];

  return [
    {
      providerName: 'Entra',
      providerId: 'entra',
      loginButtonText: process.env.REACT_APP_SSO_PROVIDER_NAME || 'Sign in with LLX Entra',
    },
  ];
};

export const redirectToOAuthProvider = async () => {
  await msalInstance.loginRedirect(loginRequest);
};

export const handleOAuthCallback = async (signinFn) => {
  let result = null;
  try {
    result = await msalInstance.handleRedirectPromise();
  } catch (err) {
    return { success: false, error: err.message || 'Entra redirect handling failed' };
  }

  if (!result) return { success: false, error: null };

  try {
    const response = await post(`${env.baseApiUrl}/api/authentication/sso/entra`, { accessToken: result.idToken });
    if (response && response.data && response.data.success) {
      if (typeof signinFn === 'function') signinFn();
      return { success: true, error: null };
    }
    return { success: false, error: 'SSO login rejected by API' };
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message || 'SSO API call failed' };
  }
};
